import Model from './model';

export default class Event extends Model {
  static NAME = 'event';
  static COLLECTION_NAME = "events";
  static URL = '/api/v2/events';
}